module.exports = __webpack_public_path__ + "static/instagram-icon-6b2b6bcd64968d1446d8154cfab85966.png";